import styles from './skeleton.module.scss';
const Skeleton = ({ height, width, borderRadius = 0 }) => {
  return (
    <div className={styles.wrapper} style={{ height, width, borderRadius }} />
  );
};

export default Skeleton;
